class PageDescriptionController {
  constructor() {
    this.DOM = {
      pageDescriptionContainer: ".js-page-description__text",
      pageDescriptionExpandButtonContainer: ".js-page-description__show-more",
      pageDescriptionExpandButton: ".js-page-description__show-more-button",
      pageDescriptionReduceButton: ".js-page-description__show-less-button",
    };

    this.mediaQuery = window.matchMedia('(max-width: 767px)');
  }

  init() {
    const container = document.querySelector(this.DOM.pageDescriptionContainer);
    const expandButtonContainer = document.querySelector(this.DOM.pageDescriptionExpandButtonContainer);
    const expandButton = document.querySelector(this.DOM.pageDescriptionExpandButton);
    const reduceButton = document.querySelector(this.DOM.pageDescriptionReduceButton);

    if (!container || !expandButtonContainer || !expandButton || !reduceButton) {
      return;
    }

    const checkAndSetup = () => {
      const lineHeight = parseFloat(getComputedStyle(container).lineHeight);
      container.style.height = 'auto';
      const actualHeight = container.scrollHeight;
      const numberOfLines = Math.round(actualHeight / lineHeight);

      if (this.mediaQuery.matches) {
        if (numberOfLines > 3.1) {
          container.style.height = `${lineHeight * 3.1}px`;
          expandButtonContainer.style.display = "block";
          reduceButton.style.display = "none";

          expandButton.onclick = () => {
            container.style.height = "auto";
            expandButtonContainer.style.display = "none";
            reduceButton.style.display = "block";
          };

          reduceButton.onclick = () => {
            container.style.height = `${lineHeight * 3.1}px`;
            expandButtonContainer.style.display = "block";
            reduceButton.style.display = "none";
          };
        } else {
          expandButtonContainer.style.display = "none";
          reduceButton.style.display = "none";
          container.style.height = "auto";
        }
      } else {
        expandButtonContainer.style.display = "none";
        reduceButton.style.display = "none";
        container.style.height = "auto";
      }
    };

    checkAndSetup();

    window.addEventListener('resize', checkAndSetup);
  }
}

export const pageDescriptionController = new PageDescriptionController();
